import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const isAuth = () => dispatch => {
	Xhr.isAuth().then((resp) => {
		if (!resp.data.isAuth) {
			dispatch({type:ACTIONS.USER.LOGOUT});
		}

		dispatch({
			type : ACTIONS.AUTH.IS_AUTH,
			data : resp.data,
		})
	});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/auth.js